import { useContext, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import toast from "react-hot-toast";
import ReactSelect from "react-select";
import calLogo from "../../assets/images/calender.svg";
import chevRight from '../../assets/images/chev-right.svg';
import SortIcon from '../../assets/images/sort-icon.svg';
import Checkbox from "../../components/layouts/CheckBox";
import CustomModal from "../../components/layouts/CustomModal";
import Button from "../../components/ui/Button";
import Skeleton from "../../components/ui/Skeleton";
import { ApiConstants } from "../../constants/ApiConstants";
import { HOUSEHOLD_TYPES, USER_ROLE_TYPES } from "../../constants/Constants";
import authContext from "../../context/authContext";
import useMakeRequest from "../../utils/ApiHelper";
import { getDateHelper, PAYMENT_METHOD } from "../../utils/Helper";
import EditAllTransaction from "./EditAllTransaction";
import EditTransaction from "./EditTransaction";
import moment from "moment";
import CustomReactSelect from "../../components/ui/CustomReactSelect";

function PaymentChart({ fromReport, members }: any) {

  let profile: any = useContext(authContext);
  profile = profile?.data;
  const transactionList = useMakeRequest();
  const hhMembers = useMakeRequest();
  const deleteTransaction = useMakeRequest();
  const _deleteAllTransaction = useMakeRequest();

  const [isPaymentChartExpanded, setIsPaymentChartExpanded] = useState(true);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: 'asc' });
  const [transactionData, setTransactionData] = useState<any[]>([]);
  const [deleteTransactionData, setDeleteTransactionData] = useState<any>();
  const [editTransaction, setEditTransaction] = useState<any>();
  const [isLoading, setIsLoading] = useState(false)
  const [selectedTransaction, setSelectedTransaction] = useState<string[]>([]);
  const [selectedTransactionArrayObj, setSelectedTransactionArrayObj] = useState<any[]>([]);
  const [showDeleteAllTransactionModal, setShowDeleteAllTransactionModal] = useState(false)


  const [paymentFilter, setPaymentFilter] = useState<any>({
    s_date: null,
    e_date: null,
    amount: "",
    method: null,
    payer: null,
    recipient: null,
  });

  const [filteredTransactionData, setFilteredTransactionData] = useState<any[]>([]);

  useEffect(() => {
    if (profile?.hh_member) {
      hhMembers.makeRequest({ url: ApiConstants?.GetHouseholdMembers })
    }
  }, [profile])

  function getLabelByValue(value: string) {
    const found = hhMembers?.data?.data.find((memb: any) => memb.user?.id === value);
    return found ? found?.user?.name : "";
  }

  useEffect(() => {
    getTransaction()
  }, [])


  useEffect(() => {
    if (transactionList?.status) {
      if (transactionList?.data?.data?.data) {
        const data = transactionList?.data?.data?.data;
        setTransactionData(data);
        setFilteredTransactionData(data);
      }
      setIsLoading(false)
    }
  }, [transactionList?.status])

  const handleFilter = (type: string = "FILTER") => {
    if (type === "RESET") {
      setPaymentFilter({
        s_date: null,
        e_date: null,
        amount: "",
        method: null,
        payer: null,
        recipient: null,
      });

      setFilteredTransactionData(transactionData);
      return;
    }

    let { s_date, e_date, amount, method, payer, recipient } = paymentFilter;

    const filtered = transactionData.filter((transaction: any) => {
      let isMatch = true;

      // ✅ Date filter
      if (s_date && e_date) {
        const txnDate = moment(transaction?.date);
        if (txnDate.isBefore(s_date) || txnDate.isAfter(e_date)) {
          isMatch = false;
        }
      } else if (s_date && moment(transaction?.date).isBefore(s_date)) {
        isMatch = false;
      } else if (e_date && moment(transaction?.date).isAfter(e_date)) {
        isMatch = false;
      }

      // ✅ Amount filter
      if (amount && Number(transaction?.amount) !== Number(amount)) {
        isMatch = false;
      }

      // ✅ Method filter
      if (method?.value !== undefined && method?.value !== "") {
        if (String(transaction?.method) !== String(method.value)) {
          isMatch = false;
        }
      }

      // ✅ Payer filter
      if (payer?.value) {
        if (String(transaction?.payer) !== String(payer.value)) {
          isMatch = false;
        }
      }

      // ✅ Recipient filter
      if (recipient?.value) {
        if (String(transaction?.receiver) !== String(recipient.value)) {
          isMatch = false;
        }
      }

      return isMatch;
    });
    console.log("filtered: ", filtered)
    setFilteredTransactionData(filtered);
  };


  console.log("filteredTransactionData: ", filteredTransactionData)



  const getTransaction = () => {
    const fetch = async () => {
      setIsLoading(true)
      await transactionList.makeRequest({
        type: 'POST',
        url: ApiConstants?.transactionList,
        payload: {
          "page": 0,
          "pageSize": 50,
          "hh_id": profile?.hh_member?.household?.id
        }
      })

    }
    fetch()
  }

  const handleSort = (key: any) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const handleTableScroll = () => {
    return
  }


  const handleDeleteAllTransactions = () => {
    const data = selectedTransaction.map(id => id)
    _deleteAllTransaction.makeRequest({
      url: ApiConstants?.deleteAllTransaction,
      payload: {
        transaction_ids: data,
      }
    })
  }
  useEffect(() => {
    if (_deleteAllTransaction?.status) {
      getTransaction()
      setDeleteTransactionData([]);
      setSelectedTransactionArrayObj([])
      setShowDeleteAllTransactionModal(false)
    }
  }, [_deleteAllTransaction?.status])

  const handleDeleteTransaction = () => {
    deleteTransaction.makeRequest({
      url: ApiConstants?.deleteTransaction,
      payload: {
        transaction_id: deleteTransactionData?.id,
      }
    })
  }


  useEffect(() => {
    if (deleteTransaction?.status) {
      getTransaction()
      setDeleteTransactionData([]);
      // setSelectedTransactionArrayObj([])
      $('.btn-close-delete-transaction-modal').click();
    }
  }, [deleteTransaction?.status])


  const toggleSelectTransaction = (id: string, transaction: any) => {
    setSelectedTransaction(prev => {
      const isSelected = prev.includes(id);

      if (isSelected) {
        // Remove from both arrays
        setSelectedTransactionArrayObj(prevArr => prevArr.filter(e => e.id !== transaction.id));
        return prev.filter(tid => tid !== id);
      } else {
        // Transform the transaction into required format
        const transformed = {
          ...transaction,
          uuid: transaction.uuid,
          id: transaction.id,
          amount: Number(transaction.amount),
          m_date: transaction.date,
          new_date: transaction.date,
          payer: transaction.payer || "",
          description: transaction.description
        };

        // Add to both arrays
        setSelectedTransactionArrayObj(prevArr => [...prevArr, transformed]);
        return [...prev, id];
      }
    });
  };

  // Calculate allowed transaction first
  const isAdmin = profile?.role_type === USER_ROLE_TYPES.GROUP_ADMIN;

  const allowedTransaction = isAdmin
    ? transactionData
    : transactionData.filter(transaction => Number(transaction?.createdBy) === Number(profile?.id) ? 1 : profile?.hh_member?.member_type === HOUSEHOLD_TYPES?.ADMIN ? 1 : 0);

  const hasNonEditable = allowedTransaction?.length <= 0
  // Correct "allSelected" condition
  const allSelected =
    allowedTransaction.length > 0 &&
    selectedTransaction.length === allowedTransaction.length;

  const toggleSelectAll = () => {
    if (allSelected) {
      setSelectedTransaction([]);
      setSelectedTransactionArrayObj([]);
      return;
    }

    const allIds = allowedTransaction.map(transaction => transaction.id);

    const transformed = allowedTransaction.map(transaction => ({
      ...transaction,
      uuid: transaction.uuid,
      id: transaction.id,
      amount: Number(transaction.amount),
      m_date: transaction.date,
      new_date: transaction.date,
      payer: transaction.payer || "",
      description: transaction.description
    }));


    setSelectedTransactionArrayObj(transformed);
    setSelectedTransaction(allIds);
  };

  return (
    <div className="page-padding-x box-bg py-4 my-3">
      <div className="row gy-3">
        <div className="com-input-grp mb-4 pt-2">
          <div className="input-header">
            <label className="form-label-large">Payment Chart</label>
            <div className="filter-section" onClick={() => setIsPaymentChartExpanded(!isPaymentChartExpanded)} style={{ cursor: 'pointer' }}>
              <span>Filter</span>
              <img
                src={chevRight}
                alt="chevron"
                style={{
                  transform: isPaymentChartExpanded ? 'rotate(90deg)' : 'rotate(0deg)',
                  transition: 'transform 0.3s ease'
                }}
              />
            </div>
          </div>
        </div>

        {isPaymentChartExpanded && (
          <>
            <div className="col-6">
              <div className="com-input-grp">
                <label className="form-label d-block">Start Date</label>
                <DatePicker
                  className="form-control"
                  placeholderText="Select Date"
                  timeFormat="MM DD YYYY"
                  onKeyDown={(e: any) => e.preventDefault()}
                  showYearDropdown
                  scrollableYearDropdown
                  yearDropdownItemNumber={50}
                  showIcon
                  icon={
                    <>
                      <img className="calIcon" src={calLogo} alt="" />
                    </>
                  }
                  selected={paymentFilter?.s_date ? moment(paymentFilter?.s_date).toDate() : null}
                  onChange={(date: any) => {
                    setPaymentFilter({ ...paymentFilter, s_date: date });
                  }}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="com-input-grp">
                <label className="form-label d-block">End Date</label>
                <DatePicker
                  className="form-control"
                  placeholderText="Select Date"
                  timeFormat="MM DD YYYY"
                  onKeyDown={(e: any) => e.preventDefault()}
                  showYearDropdown
                  scrollableYearDropdown
                  yearDropdownItemNumber={50}
                  showIcon
                  icon={
                    <>
                      <img className="calIcon" src={calLogo} alt="" />
                    </>
                  }
                  selected={paymentFilter?.e_date ? moment(paymentFilter?.e_date).toDate() : null}
                  onChange={(date: any) => {
                    setPaymentFilter({ ...paymentFilter, e_date: date });
                  }}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="com-input-grp">
                <label className="form-label d-block">Amount</label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter amount"
                  value={paymentFilter?.amount}
                  onChange={(e) =>
                    setPaymentFilter({ ...paymentFilter, amount: e.target.value })
                  }
                />
              </div>
            </div>
            <div className="col-6">
              <CustomReactSelect
                label="Method"
                value={paymentFilter?.method}
                options={PAYMENT_METHOD}
                className="com-r-select"
                classNamePrefix="com-r-select"
                placeholder="Select Method"
                onChange={(selectedOption: any) => {
                  setPaymentFilter({ ...paymentFilter, method: selectedOption });
                }}
                closeMenuOnScroll
                closeMenuOnSelect
                menuPosition="fixed"
                menuShouldScrollIntoView={false}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: base => ({ ...base, zIndex: 9999 })
                }}
              />

            </div>
            <div className="col-6">
              <CustomReactSelect
                label="Payer"
                value={paymentFilter?.payer}
                options={[
                  ...(Array.isArray(hhMembers?.data?.data)
                    ? hhMembers.data.data.map((m: any) => ({
                      value: m.user?.id,
                      label: m.user?.name,
                    }))
                    : []),
                ]}
                className="com-r-select"
                classNamePrefix="com-r-select"
                placeholder="Select Payer"
                onChange={(selectedOption: any) => {
                  setPaymentFilter({ ...paymentFilter, payer: selectedOption });
                }}
                closeMenuOnScroll
                closeMenuOnSelect
              />

            </div>
            <div className="col-6">
              <CustomReactSelect
                label="Recipient"
                value={paymentFilter?.recipient}
                options={[
                  ...(Array.isArray(hhMembers?.data?.data)
                    ? hhMembers.data.data.map((m: any) => ({
                      value: m.user?.id,
                      label: m.user?.name,
                    }))
                    : []),
                ]}
                className="com-r-select"
                classNamePrefix="com-r-select"
                placeholder="Select Recipient"
                onChange={(selectedOption: any) => {
                  setPaymentFilter({ ...paymentFilter, recipient: selectedOption });
                }}
                closeMenuOnScroll
                closeMenuOnSelect
              />

            </div>
            <div className='pb-4 d-flex'>
              <Button
                className="custom-grayed-btn modal-light-btn mt-2 me-4"
                type="button"
                style={{ width: "50%" }}
                onClick={() => handleFilter("RESET")}
              >
                Reset
              </Button>


              <Button
                className="com-btn mt-2 me-4"
                type="button"
                style={{ width: "50%" }}
                onClick={handleFilter}
              >
                Filter
              </Button>
            </div>
          </>
        )}

        <div className="page-padding-x box-bg pt-2">
          <div className="table-scroll-top" >
            <div className='table-responsive table-y-scroll-2 report-table mb-2' onScroll={handleTableScroll}>
              <table className='table'>
                <thead>
                  <tr>
                    {profile?.role_type === USER_ROLE_TYPES.GROUP_ADMIN && !fromReport &&
                      <th>
                        <Checkbox
                          checked={allSelected}
                          onChange={!hasNonEditable ? toggleSelectAll : undefined}
                          disabled={hasNonEditable}
                        />
                      </th>
                    }
                    <th>Date
                      <img
                        src={SortIcon}
                        alt="Sort"
                        className="sort-icon"
                        onClick={() => handleSort('date')}
                      />
                    </th>
                    <th className="text-center">Amount
                      <img
                        src={SortIcon}
                        alt="Sort"
                        className="sort-icon"
                        onClick={() => handleSort('amount')}
                      />
                    </th>
                    <th className="text-center">Payer
                      <img
                        src={SortIcon}
                        alt="Sort"
                        className="sort-icon"
                        onClick={() => handleSort('payer')}
                      />
                    </th>
                    <th className="text-center">Recipient
                      <img
                        src={SortIcon}
                        alt="Sort"
                        className="sort-icon"
                        onClick={() => handleSort('recipient')}
                      />
                    </th>
                    <th className="text-center">Method
                      <img
                        src={SortIcon}
                        alt="Sort"
                        className="sort-icon"
                        onClick={() => handleSort('method')}
                      />
                    </th>
                    <th className="text-center">Description
                      <img
                        src={SortIcon}
                        alt="Sort"
                        className="sort-icon"
                        onClick={() => handleSort('description')}
                      />
                    </th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    isLoading ?
                      Array.from({ length: 10 })?.map((_, key) => (
                        <tr key={key}>
                          <td className="text-center">
                            <Skeleton className='skeleton-loader' style={{ width: '100px', height: '20px' }} />
                          </td>
                          <td className="text-center">
                            <Skeleton className='skeleton-loader' style={{ width: '120px', height: '20px' }} />
                          </td>
                          <td className="text-center">
                            <Skeleton className='skeleton-loader' style={{ width: '140px', height: '20px' }} />
                          </td>
                          <td className="text-center">
                            <Skeleton className='skeleton-loader' style={{ width: '120px', height: '20px' }} />
                          </td>
                          <td className="text-center">
                            <Skeleton className='skeleton-loader' style={{ width: '120px', height: '20px' }} />
                          </td>
                          <td className="text-center">
                            <Skeleton className='skeleton-loader' style={{ width: '80px', height: '20px' }} />
                          </td>
                          <td className="text-center">
                            <Skeleton className='skeleton-loader' style={{ width: '80px', height: '20px' }} />
                          </td>
                          <td className="text-center">
                            <Skeleton className='skeleton-loader' style={{ width: '80px', height: '20px' }} />
                          </td>
                          <td className="text-center">
                            <Skeleton className='skeleton-loader' style={{ width: '80px', height: '20px' }} />
                          </td>
                        </tr>
                      )) :

                      filteredTransactionData?.length > 0 ?
                        [...filteredTransactionData]
                          ?.sort((a, b) => {
                            const { key, direction } = sortConfig;
                            if (!key) return 0;

                            let aValue, bValue;

                            switch (key) {
                              case 'date':
                                aValue = new Date(a.date);
                                bValue = new Date(b.date);
                                break;
                              case 'description':
                                aValue = a.description?.toLowerCase();
                                bValue = b.description?.toLowerCase();
                                break;
                              case 'amount':
                                aValue = a.amount?.toLowerCase();
                                bValue = b.amount?.toLowerCase();
                                break;
                              case 'payer':
                                aValue = a.payer?.label?.toLowerCase();
                                bValue = b.payer?.label?.toLowerCase();
                                break;
                              case 'recipient':
                                aValue = a.receiver?.label?.toLowerCase();
                                bValue = b.receiver?.label?.toLowerCase();
                                break;
                              case 'Method':
                                aValue = a.method?.label?.toLowerCase();
                                bValue = b.method?.label?.toLowerCase();
                                break;
                              default:
                                return 0;
                            }

                            if (aValue < bValue) return direction === 'asc' ? -1 : 1;
                            if (aValue > bValue) return direction === 'asc' ? 1 : -1;
                            return 0;
                          })?.map((transaction: any, transactionIndex: any) => {
                            const date = getDateHelper({ date: transaction?.date, format: 'MM/DD/YYYY' });
                            const desc = transaction?.description;
                            const payer = getLabelByValue(transaction?.payer);
                            const receiver = getLabelByValue(transaction?.receiver);
                            const method = PAYMENT_METHOD.find(m => m.value === String(transaction?.method))?.label || transaction?.method;
                            const amount = transaction?.amount;
                            const canEdit = Number(transaction?.c_by) === Number(profile?.id) ? 1 : profile?.hh_member?.member_type === HOUSEHOLD_TYPES?.ADMIN ? 1 : 0;

                            return (
                              <>
                                <tr key={transactionIndex}>
                                  {profile?.role_type === USER_ROLE_TYPES.GROUP_ADMIN && !fromReport &&
                                    <td>
                                      <Checkbox
                                        id={`transaction-checkbox-${transaction.id}`}
                                        checked={selectedTransaction.includes(transaction.id)}
                                        onChange={() => {

                                          const isAdmin = profile?.role_type === USER_ROLE_TYPES.GROUP_ADMIN;
                                          if (isAdmin || canEdit) {
                                            toggleSelectTransaction(transaction.id, transaction);
                                          } else {
                                            toast.error("You cannot edit other's transaction");
                                          }
                                        }}
                                      />
                                    </td>
                                  }
                                  <td className="text-center">{date}</td>
                                  <td className="text-center">{amount}</td>
                                  <td className="text-center">{transaction?.payer == -1 ? "Joint Account" : payer}</td>
                                  <td className="text-center">{transaction?.receiver == -1 ? "Joint Account" : receiver}</td>
                                  <td className="text-center">{method}</td>
                                  <td className="text-center">{desc}</td>

                                  <td className='pay-status'>
                                    <div className="d-flex align-items-center">

                                      {!fromReport &&

                                        <>
                                          <span className="action-icon cursor-pointer"
                                            data-bs-toggle="modal"
                                            data-bs-target="#transactionUpdateModal"
                                            onMouseDown={(e) => e.preventDefault()}
                                            onClick={(e: any) => {
                                              e.preventDefault();
                                              setSelectedTransaction([]);
                                              setSelectedTransactionArrayObj([])
                                              setEditTransaction(transaction)
                                            }}
                                          >
                                            <svg
                                              className="edit-icon"
                                              width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <g clip-path="url(#clip0_58545_4835)">
                                                <path d="M6.98438 3.5L10.4934 7.00001" stroke="currentColor" stroke-width="0.875" stroke-linejoin="round" />
                                                <path d="M7.56836 12.832H12.8319" stroke="currentColor" stroke-width="0.875" stroke-linejoin="round" />
                                                <path d="M1.16804 9.33953L9.31264 1.17069C9.3162 1.16709 9.32203 1.16706 9.32565 1.17063L12.8281 4.66833C12.8304 4.67062 12.8304 4.6743 12.8281 4.67658L4.66333 12.8348H1.16797L1.16804 9.33953Z" stroke="#263C4A" stroke-width="0.875" />
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_58545_4835">
                                                  <rect width="14" height="14" fill="white" />
                                                </clipPath>
                                              </defs>
                                            </svg>


                                          </span>
                                          <div className="vertical-icon-separator" />
                                          <span
                                            className="action-icon del cursor-pointer"
                                            data-bs-toggle="modal"
                                            data-bs-target="#deleteTransacctionModal"
                                            onClick={() => {
                                              setSelectedTransaction([]);
                                              setSelectedTransactionArrayObj([])
                                              setDeleteTransactionData(transaction)
                                            }}>
                                            <svg className="del-icon" width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M5.25 6.70703H8.75" stroke="currentColor" stroke-width="0.875" stroke-linejoin="round" />
                                              <path d="M6.125 9.04297H7.875" stroke="currentColor" stroke-width="0.875" stroke-linejoin="round" />
                                              <path d="M11.375 3.20703L10.7917 12.832H3.20833L2.625 3.20703" stroke="currentColor" stroke-width="0.875" stroke-linejoin="round" />
                                              <path d="M1.16797 3.20964H4.66797M4.66797 3.20964L5.54297 1.16797H8.45964L9.33464 3.20964M4.66797 3.20964H9.33464M12.8346 3.20964H9.33464" stroke="currentColor" stroke-width="0.875" stroke-linejoin="round" />
                                            </svg>
                                          </span>
                                        </>
                                        // <>
                                        //   <span className="action-icon cursor-pointer"
                                        //     data-bs-toggle="modal"
                                        //     data-bs-target="#transactionUpdateModal"
                                        //     onMouseDown={(e) => e.preventDefault()}
                                        // onClick={(e: any) => {
                                        //   e.preventDefault();
                                        //   setSelectedTransaction([]);
                                        //   setSelectedTransactionArrayObj([])
                                        //   setEditTransaction(transaction)
                                        // }}
                                        //   >
                                        //     <a className='icon-edit'></a>
                                        //   </span>
                                        //   <span className="action-icon del cursor-pointer" data-bs-toggle="modal" data-bs-target="#deleteTransacctionModal" 
                                        // onClick={() => {
                                        //     setSelectedTransaction([]);
                                        //     setSelectedTransactionArrayObj([])
                                        //     setDeleteTransactionData(transaction)
                                        //   }} >
                                        //     <i className="icon-delete"></i>
                                        //   </span>
                                        // </>
                                      }
                                    </div>
                                  </td>
                                </tr>
                              </>
                            )
                          })
                        :
                        <>
                          <tr>
                            <td colSpan={20}>
                              <p className="text-center mt-3">No Record Found</p>
                            </td>
                          </tr>
                        </>
                  }
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {!fromReport &&
          <div className="d-flex align-items-center justify-content-center">
            <button
              className="com-btn me-2"
              style={{ width: "50%" }}
              data-bs-toggle={selectedTransaction?.length > 0 ? "modal" : ""}
              data-bs-target={selectedTransaction?.length > 0 ? "#EditAllTransactionModal" : ""}
              onClick={(e) => {
                if (selectedTransaction?.length === 0) {
                  e.preventDefault();
                  e.stopPropagation();
                }
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="me-2 btn-icon"
              >
                <path
                  d="M9.97754 5L14.9905 10"
                  stroke="currentColor"
                  stroke-width="1.04167"
                  stroke-linejoin="round"
                />
                <path
                  d="M10.8135 18.334H18.3328"
                  stroke="currentColor"
                  stroke-width="1.04167"
                  stroke-linejoin="round"
                />
                <path
                  d="M1.66709 13.3397L13.3022 1.66991C13.3073 1.66476 13.3156 1.66471 13.3208 1.66981L18.3243 6.66654C18.3276 6.6698 18.3276 6.67506 18.3243 6.67832L6.66037 18.3329H1.66699L1.66709 13.3397Z"
                  stroke="currentColor"
                  stroke-width="1.04167"
                />
              </svg>
              Edit
            </button>
            <button
              className="com-btn"
              style={{ width: "50%" }}
              // data-bs-toggle={selectedTransaction?.length > 0 ? "modal" : ""}
              // data-bs-target={selectedTransaction?.length > 0 ? "#deleteAllExpenseModal" : ""}
              onClick={(e) => {
                if (selectedTransaction?.length > 0) {
                  e.preventDefault();
                  e.stopPropagation();
                  setShowDeleteAllTransactionModal(true)
                }
              }}
            >
              {/* <img src={binIcon} className="me-2 btn-icon" />  */}
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="me-2 btn-icon"
              >
                <path
                  d="M7.49902 9.58594H12.499"
                  stroke="currentColor"
                  stroke-width="1.04167"
                  stroke-linejoin="round"
                />
                <path
                  d="M8.74902 12.9141H11.249"
                  stroke="currentColor"
                  stroke-width="1.04167"
                  stroke-linejoin="round"
                />
                <path
                  d="M16.249 4.58594L15.4157 18.3359H4.58236L3.74902 4.58594"
                  stroke="currentColor"
                  stroke-width="1.04167"
                  stroke-linejoin="round"
                />
                <path
                  d="M1.66797 4.58073H6.66797M6.66797 4.58073L7.91797 1.66406H12.0846L13.3346 4.58073M6.66797 4.58073H13.3346M18.3346 4.58073H13.3346"
                  stroke="currentColor"
                  stroke-width="1.04167"
                  stroke-linejoin="round"
                />
              </svg>
              Delete</button>
          </div>
        }
      </div>

      <div className="modal fade inner-modal com-modal" id="deleteTransacctionModal" tabIndex={-1} aria-labelledby="deleteTransacctionLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-body pt-4 pb-0">
              <p className='com-modal-para mb-2 mt-3'>Are you sure you would like to <br /> delete this payment?</p>
            </div>
            <div className='modal-footer border-0 mt-3 justify-content-center'>
              <button type='button' className='com-btn com-btn-gray btn-close-delete-transaction-modal' data-bs-dismiss="modal" >Cancel</button>
              <Button type='button' className='com-btn' onClick={handleDeleteTransaction} loading={deleteTransaction?.loading}>Confirm</Button>
            </div>
          </div>
        </div>
      </div>

      {showDeleteAllTransactionModal &&
        <CustomModal
          title='Are you sure you would like to delete these transactions?'
          buttonTxt={'Delete'}
          onConfirm={handleDeleteAllTransactions}
          toggleModal={() => {
            setSelectedTransaction([])
            setSelectedTransactionArrayObj([])
            setShowDeleteAllTransactionModal(false)
          }}
        />
      }

      <EditTransaction
        hhMembers={hhMembers}
        editTransaction={editTransaction}
        members={members}
        onCancel={() => setEditTransaction(null)}
        onSuccess={() => {
          getTransaction()
          setEditTransaction(null)
        }}
      />

      <EditAllTransaction
        hhMembers={hhMembers}
        editTransaction={selectedTransactionArrayObj}
        members={members}
        onCancel={() => setEditTransaction(null)}
        onSuccess={() => {
          getTransaction()
          setEditTransaction(null)
          setSelectedTransaction([]);
          setSelectedTransactionArrayObj([])
        }}
      />
    </div>
  );
}

export default PaymentChart;
